import React from "react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import AboutUsTitle from "../atoms/aboutUsParts/aboutUsTitle";
import AboutUsIndex from "../atoms/aboutUsParts/aboutUsIndex";
import AboutUsValores from "../atoms/aboutUsParts/aboutUsValores";
import AboutUsPromise from "../atoms/aboutUsParts/aboutUsPromise";
import AboutUsEquipo from "../atoms/aboutUsParts/aboutUsEquipo";
import AboutUsFooter from "../atoms/aboutUsParts/aboutUsFooter";

export const AboutUs: React.FC = () => {
  const { useSectionInView, scrollToSection } = useScrollAnimation();

  const sections = [
    { id: "title", component: <AboutUsTitle /> },
    { id: "index", component: <AboutUsIndex /> },
    { id: "values", component: <AboutUsValores /> },
    { id: "promise", component: <AboutUsPromise /> },
    { id: "team", component: <AboutUsEquipo /> },
    {
      id: "footer",
      component: <AboutUsFooter scrollToSection={scrollToSection} />,
    },
  ];

  return (
    <div className="h-[100svh] w-screen overflow-y-auto snap-y snap-mandatory snap-always scroll-smooth overscroll-contain touch-pan-y scroll-pt-0">
      {sections.map((section) => {
        const { ref } = useSectionInView(section.id);

        return (
          <section
            key={section.id}
            ref={ref}
            className="snap-start flex-none h-[100svh] w-full flex items-center justify-center"
          >
            <div className="w-full h-full">{section.component}</div>
          </section>
        );
      })}
    </div>
  );
};
export default AboutUs;
